module.exports = __webpack_public_path__ + "img/card3.d47e83d9.png";